import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';
import { CREATOR_METRICS_TIMELINE_QUERY_KEY } from '~/queries/keys';

export interface TimelineMetrics {
  followers: number;
  followers_growth: number | null;
  followers_growth_rate: number | null;
}

export interface TimelineEntry {
  date: string;
  metrics: TimelineMetrics;
}

export interface Timeline {
  DAILY?: TimelineEntry[];
  WEEKLY?: TimelineEntry[];
  MONTHLY?: TimelineEntry[];
}

export interface CreatorMetricsTimeline {
  external_id: string;
  platform: string;
  timeline: Timeline;
  status?: string;
}

interface UseGetCreatorMetricsTimelineParams {
  creatorId?: string;
  platform?: string;
  shareToken?: string;
}

export const useGetCreatorMetricsTimeline = ({
  creatorId,
  platform,
  shareToken,
}: UseGetCreatorMetricsTimelineParams) => {
  return useQuery({
    queryKey: [CREATOR_METRICS_TIMELINE_QUERY_KEY, { creatorId, platform }],
    queryFn: () =>
      apiClientV2
        .get<CreatorMetricsTimeline>(
          `/creators/${creatorId}/metrics/timeline/${platform}`,
          shareToken ? { headers: { 'X-AUTH-TOKEN': shareToken } } : undefined,
        )
        .then((r) => r.data),
    enabled: Boolean(creatorId) && Boolean(platform),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
